import { Header4, Paragraph2 } from '@cian/ui-kit';

import * as React from 'react';
import classNames from 'classnames';

import * as styles from './styles.css';
// @ts-ignore
import * as image from '../CoworkingModalAd/fire.png';

interface ICoworkingHelper {
  className?: string;
}

export const CoworkingHelper: React.FC<ICoworkingHelper> = ({ className }) => (
  <div className={classNames(styles['root'], className)}>
    <div className={styles['header']}>
      <Header4 color="white_100">У нас есть офисы в коворкингах!</Header4>
    </div>
    <Paragraph2 color="white_100">
      Это выгоднее, чем обычный офис
      <img src={image} className={styles['icon']} />
    </Paragraph2>
  </div>
);

CoworkingHelper.displayName = 'CoworkingHelper';
